import { Container, Paper, Stack } from "@mui/material";
import "./Content.css";
import BreadcrumbsBar from "components/Breadcrumbs";
import MenuBar from "components/Layout/Menu/Layout1";
import { ProviderLayout } from "view/ExampleLayout/Admin";
import { useContext } from "react";
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import theme from "theme/themes";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    marginTop: '96px',
    marginLeft: '11px',
    borderRight: '0 !important',
    backgroundColor: 'transparent !important',
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    borderRight: '0 !important',
    backgroundColor: 'transparent !important',
    overflowX: 'hidden',
    marginTop: '96px',
    marginLeft: '11px',
    width: `calc(${theme.spacing(7)} + 1px)`,
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        marginTop: '111px',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        borderRight: '0 !important',
        backgroundColor: 'transparent !important',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const Content = (props) => {

    const {
        IsMenuOpen,
        Layout630
    } = useContext(ProviderLayout)

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Paper
                elevation={0}
                sx={{
                    display: Layout630 ? "" : "none",
                    width: IsMenuOpen ? drawerWidth : `calc(${theme.spacing(7)} + 1px)`,
                    marginTop: '105px',
                    marginLeft: '11px',
                    flexShrink: 0,
                    borderRight: '0 !important',
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box',
                    backgroundColor: 'transparent !important',
                    transition: theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                }}>
                <MenuBar />
            </Paper>
            <Box component="main" sx={{ overflowX:'auto',flexGrow: 1, p: 3, mt: "80px", width: Layout630 && !IsMenuOpen ? '100%' : '80%' }}>
                {/* <DrawerHeader /> */}
                <Container maxWidth={false} className="div-backgournd-content-detail">
                    <Stack spacing={2}>
                        <Paper style={{boxShadow:"unset"}} >
                            <BreadcrumbsBar />
                        </Paper>
                        <Paper className="div-backgournd-content-children">
                            {props.children}
                        </Paper>
                    </Stack>
                </Container>
            </Box>
        </Box>
    )
}
export default Content;
